import React from 'react';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { useAlert } from '../../hooks/useAlert';
import AlertComponent from './Alert';

const AlertContainer: React.FC = () => {
    const { alerts, hideAlert } = useAlert();

    // Определяем позицию в зависимости от размера экрана
    const position = useBreakpointValue({
        base: {
            position: 'fixed',
            top: 4,
            left: 4,
            right: 4,
            bottom: 'auto',
            maxW: 'none',
        },
        md: {
            position: 'fixed',
            top: 4,
            right: 4,
            left: 'auto',
            bottom: 'auto',
            maxW: '400px',
        },
    });

    if (alerts.length === 0) {
        return null;
    }

    return (
        <Box
            position={position?.position}
            top={position?.top}
            right={position?.right}
            left={position?.left}
            bottom={position?.bottom}
            zIndex={1000}
            maxW={position?.maxW}
        >
            {alerts.map((alert, index) => (
                <Box key={alert.id} mb={index < alerts.length - 1 ? 2 : 0}>
                    <AlertComponent alert={alert} onClose={hideAlert} />
                </Box>
            ))}
        </Box>
    );
};

export default AlertContainer;
